import React from 'react'
import Nav from './Nav'
import { IProps } from './types'
import Footer from './Footer'
import { Check as CheckIcon, Close2 as CloseIcon } from 'components/Icons'

export function ProductLayout({ title, children, showNav = true, showFooter = true }: IProps): JSX.Element {
    return (
        <div className="px-5 py-12">
            {showNav && <Nav />}
            <div>{children}</div>
            {showFooter && <Footer title={title} />}
        </div>
    )
}

export const Check = (props: any) => <CheckIcon {...props} className="mx-auto w-5" />
export const Close = (props: any) => <CloseIcon {...props} className="mx-auto w-5" />
export default ProductLayout
export { Comparison } from './Comparison'
export { Testimonial } from './Testimonial'
